import type { ProductListingPage } from "@decocms/apps-commerce/types"

import { BrandPaginationBottom } from "./BrandPaginationBottom"
import { BrandPaginationTop } from "./BrandPaginationTop"
import ProductCard from "~/components/product/ProductCard"
import trimProductForShelf from "~/sdk/trimProductForShelf"

export interface Props {
	page: ProductListingPage | null
}

function BrandProducts({ page, url, isMobile }: Awaited<ReturnType<typeof loader>>) {
	if (!page) return null

	return (
		<div className='w-full max-w-[1834px] px-4 mx-auto mt-5 md:mt-3 flex flex-col gap-5'>
			<BrandPaginationTop page={page} url={url} isMobile={isMobile} />

			<ul className='grid justify-between gap-x-6 gap-y-5 lg:gap-x-2 grid-cols-2 lg:grid-cols-5'>
				{page.products?.map((product, index) => (
					<li key={`product-card-${product.productID}`}>
						<ProductCard
							product={product}
							preload={index === 0}
							isMobile={isMobile as boolean}
							index={index}
						/>
					</li>
				))}
			</ul>

			<BrandPaginationBottom page={page} url={url} />
		</div>
	)
}

export const loader = (props: Props & { __pageUrl?: string; isMobile?: boolean }) => {
	const url = props.__pageUrl ?? "/"
	const isMobile = props.isMobile ?? false
	const { page } = props

	return {
		...props,
		// Immutable copy — the resolved page is memo-shared with PageSEO's
		// JSON-LD (bots need full variants). See ~/sdk/trimProductForShelf.
		page: page && { ...page, products: page.products.map(trimProductForShelf) },
		url,
		isMobile,
	}
}

export default BrandProducts
